import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0234',
    ecrans: ['00-2']
});
